import { checkResponse, get, e, put, post, remove } from '../helpers/http'

export function getSites () {
  return get(e(`/api/v2/sites/`))
    .then(checkResponse)
}

export function createSite (data) {
  return post(e(`/api/v2/sites/`), data)
    .then(checkResponse)
}

export function getTagList ({ term, site, limit = 50   }) {
  return get(e(`/api/v2/${site}/tag_autocomplete`), {term, limit})
    .then(checkResponse)
}

export function getCatalog ({site, catalog, data}) {
  return get(e(`/api/v2/${site}/catalog/${catalog}`), data)
    .then(checkResponse)
}

export function getBuilds ({project, filter}) {
  const query = { ...filter }
  if (filter.tags && filter.tags.length) {
    query.tags = filter.tags.join(',')
  }
  if (filter.exclude_tags && filter.exclude_tags.length) {
    query.exclude_tags = filter.exclude_tags.join(',')
  }
  return get(e(`/api/v2/${project}/builds`), query)
    .then(checkResponse)
}

export function getMilestone ({project, filter}) {
  const query = { ...filter }
  if (filter.tags && filter.tags.length) {
    query.tags = filter.tags.join(',')
  }
  if (filter.exclude_tags && filter.exclude_tags.length) {
    query.exclude_tags = filter.exclude_tags.join(',')
  }
  return get(e(`/api/v2/${project}/builds/milestone`), query)
    .then(checkResponse)
}

export function getBuild ({build_id}) {
  return get(e(`/api/v3/builds/${build_id}`))
    .then(checkResponse)
}

export function getTeamcityBuild(buildId) {
  return get(e(`/api/v3/builds/tc/${buildId}`))
    .then(checkResponse);
}

export function getSingleBuild (build_id) {
  return get(e(`/api/v3/builds/${build_id}`))
    .then(checkResponse)
}

export function getHashBuild ({project, hash}) {
  return get(e(`/api/v2/${project}/builds/token/${hash}`))
    .then(checkResponse)
}

export function getVersionBuild ({project, build_id, id}) {
  return get(e(`/api/v2/${project}/builds/${build_id}/versions/${id}`))
    .then(checkResponse)
}

export function getVersionBuildNoProject ({build_id, id}) {
  return get(e(`/api/v3/builds/${build_id}/versions/${id}`))
    .then(checkResponse)
}

export function saveBuild ({build_id, data}) {
  return put(e(`/api/v3/builds/${build_id}`), data)
    .then(checkResponse)
}

export function uploadBuild ({project, data}) {
  return post(e(`/api/v2/${project}/builds/upload`), data)
    .then(checkResponse)
}

export function createBuild ({project, data}) {
  return post(e(`/api/v2/${project}/builds`), data)
    .then(checkResponse)
}

export function createVersion ({build_id, data}) {
  return post(e(`/api/v3/builds/${build_id}/versions`), data)
    .then(checkResponse)
}

export function reuploadVersion ({project, build_id, id, data}) {
  return post(e(`/api/v2/${project}/builds/${build_id}/versions/${id}/set_s3_key`), data)
    .then(checkResponse)
}

export function getBuildVersions(buildId, data) {
  return get(e(`/api/v3/builds/${buildId}/versions`), data)
    .then(checkResponse)
}

export function setMilestone ({build_id, id, data}) {
  return post(e(`/api/v3/builds/${build_id}/versions/${id}/set_milestone`), data)
    .then(checkResponse)
}

export function setCurrent ({build_id, id}) {
  return post(e(`/api/v3/builds/${build_id}/versions/${id}/set_current`))
    .then(checkResponse)
}

export function branchNames ({project, filter}) {
  const query = { ...filter }
  if (filter.tags && filter.tags.length) {
    query.tags = filter.tags.join(',')
  }
  if (filter.exclude_tags && filter.exclude_tags.length) {
    query.exclude_tags = filter.exclude_tags.join(',')
  }
  return get(e(`/api/v2/${project}/branch_names`), query)
    .then(checkResponse)
}

export function sharedLinkes (data) {
  return post(e(`/api/v2/${data.project}/builds/${data.build_id}/versions/${data.id}/shared_links`))
    .then(checkResponse)
}

export function getSharedLinks ({project, filter}) {
  return get(e(`/api/v2/${project}/shared_links`), filter)
    .then(checkResponse)
}

export function deleteSharedLinks ({project, hash}) {
  return remove(e(`/api/v2/${project}/shared_links/${hash}`))
    .then(checkResponse)
}

export function trigerringBuild ({build_id, id}) {
  return get(e(`/api/v3/builds/${build_id}/versions/${id}/triggering_build`))
    .then(checkResponse)
}
